module.exports = __webpack_public_path__ + "img/qr_code.17230807.png";